export interface RefreshTokenOutDto {
    token: string;
}
export interface RefreshTokenInDto {
    ok: boolean;
    token: string;
}

export interface testRefreshToken {
    token: string;
    exp: number | Date | string;
}

export enum RefreshTokenTime {
    REFRESH_BEFORE = 10,//minutos
    REFRESH_BETWEEN = 5,//el total del tiempo de expiración del token se divide en estas partes para revisar la expiración
    INACTIVITY_MODAL = 15, //15 minutos
    INACTIVITY_CLOSE_MODAL = 180, //3 minutos
}
  